<div *ngIf="gdo != null && (viewType == null || viewType == 'List')">
  <div class="thumbnail hidden-xs sp-gdo-value">
    <div class="col-md-1 col-sm-1 pull-left">
      <div>
        <img [src]="gdoStatusImage" class="lock gdo-list" alt="">
      </div>
    </div>
    <div class="col-md-5 col-sm-6">
      <div class="sp-gdo-name">
        <div class="row">
          {{gdo.deviceName}}
        </div>
        <div class="row">
          <div class="sp-gdo-type pull-left">
            {{('GDO.DETAIL.GDO_STATUS' | translate)}}:
            <span class="sp-gdo-State">{{deviceStatus}}</span>
          </div>
          <div class="sp-gdo-type-list pull-right">
            {{('GDO.DETAIL.LAST_ACTIVITY' | translate)}}:
            <span>{{lastActivity}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-2 sp-gdo-battery">
      <div class="row">
        <div class="col-md-12 col-sm-12 pull-right">
          <div class="col-md-6 col-sm-6 sp-battery-img">
            <app-gdo-battery [isUnknownStatus]="isUnknownStatus" [connectedAC] = 'gdo.connectedAC' [batteryVoltage] = 'gdo.batteryVoltage' ></app-gdo-battery>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-sm-3 pull-right">
      <div class="col-md-12 col-sm-12 text-right">
        <img src="./../../../../assets/images/gdo/history.svg"
        alt="history.png" class="history click click-history gdo-history-list" *ngIf="member" (keydown.enter)="historyRef.click()" #historyRef
        [routerLink]="['/gdo/history', gdo.deviceId]">

          <img (keydown.enter)="settingRef.click()" #settingRef src="../../../../assets/images/gdo/setting.svg" *ngIf="member"
               [routerLink]="['/gdo/details', gdo.deviceId]" alt="settings.png"
               class="gdo-settings click">

        <img src="../../../../assets/images/gdo/history.svg" *ngIf="!member"
          alt="history.png" class="history gdo-history-list custom-disabled">

          <img src="../../../../assets/images/gdo/setting.svg" *ngIf="!member" alt="settings.png"
          class="gdo-settings custom-disabled">

      </div>
    </div>
    <div *ngIf="(isIssue || isWarning)" class="caption sp-gdo-list-alert sp-gdo-list-sm-alert" [ngClass]="{'sp-gdo-list-ble-alert' : isWarning}">
      <div class="col-md-1 col-sm-2 pull-left">
        <img [src]="issueIcon" alt="alert-icon.png">
      </div>
      <div class="col-md-11 col-sm-10 pull-right">
        <p class="alert-text alert-text-list">{{issueMessage}}</p>
      </div>
    </div>
  </div>

  <div class="col-xs-12 col-sm-5 col-md-4 visible-xs">
    <div class="thumbnail sp-gdo-list-sm">
      <div class="col-xs-2 pull-left">
        <div>
          <img [src]="gdoStatusImage" class="lock gdo-list-sm" alt="">
        </div>
      </div>
      <div class="col-xs-8">
        <div class="sp-gdo-name-list-sm">
          <div class="row">
            {{gdo.deviceName}}
          </div>
          <div class="row sp-gdo-type-grid">
            {{('GDO.DETAIL.GDO_STATUS' | translate)}}: <span class="sp-gdo-State">{{deviceStatus}}</span>
          </div>
        </div>
        <div class="sp-gdo-last-activity-list-sm">
          <div class="row sp-gdo-type-list-sm">
            {{('GDO.DETAIL.LAST_ACTIVITY' | translate)}}: <span>{{lastActivity}}</span>
          </div>
        </div>
      </div>
      <div class="col-xs-2 pull-right">
        <div class="row">
          <div class="col-xs-12 pull-right pos-bottom">
            <img src="../../../../assets/images/gdo/setting.svg" *ngIf="member"
              [routerLink]="['/gdo/details', gdo.deviceId]" alt="settings.png"
              class="gdo-settings gdo-settings-list-sm pull-right click">

            <img src="../../../../assets/images/gdo/setting.svg" *ngIf="!member" alt="settings.png"
              class="gdo-settings gdo-settings-list-sm pull-right custom-disabled">

            <img src="./../../../../assets/images/gdo/history.svg"
              *ngIf="member" alt="history.png"
              class="gdo-settings gdo-history-sm pull-left click" [routerLink]="['/gdo/history', gdo.deviceId]">

            <img src="../../../../assets/images/gdo/history.svg" *ngIf="!member"
              alt="history.png" class="gdo-settings gdo-history-sm pull-left custom-disabled">
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 list-view pull-right">
             <div class="sp-gdo-battery-img-grid">
              <app-gdo-battery [isUnknownStatus]="isUnknownStatus" [connectedAC] = 'gdo.connectedAC' [batteryVoltage] = 'gdo.batteryVoltage' ></app-gdo-battery>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="(isIssue || isWarning)" [ngClass]="{'sp-gdo-list-ble-alert' : isWarning}"
        class="caption sp-gdo-list-sm-alert">
        <div class="col-sm-2 col-xs-2 pull-left">
          <img [src]="issueIcon" alt="alert-icon.png" class="alert-icon">
        </div>
        <div class="col-sm-10 col-xs-10 pull-right">
          <p class="alert-text alert-text-list-sm">
            {{issueMessage}}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="gdo != null && viewType != null && viewType == 'Grid'">
    <div class="thumbnail sp-gdo-grid">
      <div class="col-xs-9 col-md-10 col-sm-10 pull-left base">
        <div>
          <img [src]="gdoStatusImage"
               class="lock gdo-grid" alt="">
          <img *ngIf="member" src="./../../../../assets/images/gdo/history.svg"
               tabindex="0" #historyFilter (keydown.enter)="historyFilter.click()" alt="history.png"
               class="history click click-history pull-right gdo-history history-icon"
               [routerLink]="['/gdo/history', gdo.deviceId]">
          <img src="../../../../assets/images/gdo/history.svg" *ngIf="!member"
               alt="history.png" class="history click click-history pull-right gdo-history history-icon custom-disabled">
        </div>
        <div class="sp-gdo-name-grid">
          <div class="row goth-heading ellipsis">
            {{gdo.deviceName}}
          </div>
          <div class="row sp-gdo-type-grid">
            {{('GDO.DETAIL.GDO_STATUS' | translate)}}:
            <span class="sp-gdo-State">{{deviceStatus}}</span>
          </div>
        </div>
        <div class="sp-gdo-last-activity-grid">
          <div class="row sp-gdo-type-grid">
            {{('GDO.DETAIL.LAST_ACTIVITY' | translate)}}:
            <span>{{lastActivity}}</span>
          </div>
        </div>
      </div>
      <div class="col-xs-3 col-md-2 col-sm-2 pull-right detail">
        <div class="row">
          <div class="col-md-6 pull-right detail-main">
            <img src="../../../../assets/images/gdo/setting.svg" #settingFilter (keydown.enter)="settingFilter.click()" *ngIf="member"
                 [routerLink]="['/gdo/details', gdo.deviceId]" alt="settings.png"
                 class="gdo-settings gdo-setting-grid click">
            <img src="../../../../assets/images/gdo/setting.svg" *ngIf="!member" alt="settings.png"
              class="gdo-settings gdo-setting-grid click custom-disabled">
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 grid-view pull-right">
              <app-gdo-battery [isUnknownStatus]="isUnknownStatus" [connectedAC] = 'gdo.connectedAC' [batteryVoltage] = 'gdo.batteryVoltage'></app-gdo-battery>
          </div>
        </div>
      </div>
      <div *ngIf="(isIssue || isWarning)" class="caption sp-gdo-grid-alert" [ngClass]="{'sp-ble-alert' : isWarning}">
        <div class="row">
        <div class="col-sm-2 col-xs-2 pull-left">
          <img [src]="issueIcon" alt="alert-icon.png" class="alert-icon">
        </div>
        <div class="col-sm-10 col-xs-10 pull-right">
          <p class="alert-text">{{issueMessage}}</p>
        </div>
        </div>
      </div>
    </div>
</div>
